import { useDeviceType } from '@cian/ui-kit';
import { useSelector } from 'react-redux';

import { useIsOfferCardPage } from './useIsOfferCardPage';
import { selectPageType } from '../selectors/page';
import { TPageType } from '../types/page';
import { useApplicationContext } from '../utils/applicationContext';

const INCLUDED_PAGES: TPageType[] = [
  'main',
  'mainCountryside',
  'mainSale',
  'mainRent',
  'mainRentDaily',
  'favorites',
  'chats',
  'lk',
];

export const useMobileBottomNavigation = () => {
  const { config } = useApplicationContext();

  const isMobileBottomNavigationEnabled =
    config.get<boolean>('header-frontend.mobileBottomNavigation.Enabled') ?? false;

  const pageType = useSelector(selectPageType);

  const isOfferCardPage = useIsOfferCardPage();

  const deviceType = useDeviceType();

  return (
    isMobileBottomNavigationEnabled &&
    deviceType !== 'desktop' &&
    (INCLUDED_PAGES.includes(pageType) || ((pageType === 'search' || pageType === 'offerCard') && !isOfferCardPage))
  );
};
